/** @flow */

import type { EmployeeEventsState } from "@modules/shared/reducer/employee-events/types";

export const defaultEventHistory = {
  ALL: {
    content: [],
    pagination: {
      sort: { orders: [] },
      pageNumber: 0,
      pageSize: 0,
      offset: 0,
    },
    totalElements: 0,
  },
  ALERT_TRIGGERED: {
    content: [],
    pagination: {
      sort: { orders: [] },
      pageNumber: 0,
      pageSize: 0,
      offset: 0,
    },
    totalElements: 0,
  },
  RTW_INTERVIEW: {
    content: [],
    pagination: {
      sort: { orders: [] },
      pageNumber: 0,
      pageSize: 0,
      offset: 0,
    },
    totalElements: 0,
  },
  MANAGER_REFERRAL_DECISION: {
    content: [],
    pagination: {
      sort: { orders: [] },
      pageNumber: 0,
      pageSize: 0,
      offset: 0,
    },
    totalElements: 0,
  },
  MANUAL_REFERRAL: {
    content: [],
    pagination: {
      sort: { orders: [] },
      pageNumber: 0,
      pageSize: 0,
      offset: 0,
    },
    totalElements: 0,
  },
  EMPLOYEE_REFERRAL_DECISION: {
    content: [],
    pagination: {
      sort: { orders: [] },
      pageNumber: 0,
      pageSize: 0,
      offset: 0,
    },
    totalElements: 0,
  },
  SUPPLIER_REFERRAL_TRACKING: {
    content: [],
    pagination: {
      sort: { orders: [] },
      pageNumber: 0,
      pageSize: 0,
      offset: 0,
    },
    totalElements: 0,
  },
  ABSENCE_MONITORING_REVIEW: {
    content: [],
    pagination: {
      sort: { orders: [] },
      pageNumber: 0,
      pageSize: 0,
      offset: 0,
    },
    totalElements: 0,
  },
  ABSENCE_MONITORING_TASK: {
    content: [],
    pagination: {
      sort: { orders: [] },
      pageNumber: 0,
      pageSize: 0,
      offset: 0,
    },
    totalElements: 0,
  },
  REFERRALS: {
    content: [],
    pagination: {
      sort: { orders: [] },
      pageNumber: 0,
      pageSize: 0,
      offset: 0,
    },
    totalElements: 0,
  },
};

export const initialState: EmployeeEventsState = {
  requestsInProgress: 0,
  error: null,
  isEmployeeEligible: true,
  isManualReferralAvailable: true,
  eventHistory: defaultEventHistory,
  documents: {
    content: [],
    pagination: {
      sort: { orders: [] },
      pageNumber: 0,
      pageSize: 0,
      offset: 0,
    },
    totalElements: 0,
  },
  specificDocuments: {
    content: [],
    pagination: {
      sort: { orders: [] },
      pageNumber: 0,
      pageSize: 0,
      offset: 0,
    },
    totalElements: 0,
  },
  modals: {
    removeDocument: {
      visible: false,
      documentId: null,
      documentName: null,
    },
    addDocument: {
      visible: false,
    },
    eventHistoryItem: {
      visible: false,
    },
    absenceReviewItem: {
      visible: false,
    },
    referralDecisionModal: {
      visible: false,
    },
    manualReferral: {
      visible: false,
      processes: {
        content: [],
        pagination: {
          pageNumber: 0,
          pageSize: 0,
          offset: 0,
        },
        totalElements: 0,
      },
    },
    manualReferralTaskDataModal: {
      visible: false,
      taskData: {
        id: 0,
        manual_referral_id: 0,
        question_answers: [],
        reason: { id: 0, reason: null, isActive: null },
      },
    },
  },
};

export default initialState;
